import { OverlayRef } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export type ToasterMessageType = 'message' | 'warning' | 'error';

export interface ToasterMessageData {
    message: string;
    messageType: ToasterMessageType;
    overlayRef: OverlayRef;
    autoClose: boolean
}

export const TOASTER_CONTAINER_DATA = new InjectionToken<ToasterMessageData>('TOASTER_CONTAINER_DATA');

/**
 * Set how long (in milliseconds) Toaster will wait before automatically closing the "message" type notification.
 * Default value is set to 30000ms
 */
export const TOASTER_DEFAULT_AUTOCLOSE = 30000;
/**
 * Set should Toaster autoclose after TOASTER_DEFAULT_AUTOCLOSE time.
 */
export const TOASTER_AUTOCLOSE_FLAG = new InjectionToken<boolean>('TOASTER_AUTOCLOSE_FLAG');
